import Popup from "@/shared/components/layers/Popup/Popup"
import { EditPlanPopupProps } from "./EditPlanPopup.model"
import css from '../CreatePlanPopup/CreatePlanPopup.module.css'
import newcss from './EditPlanPopup.module.css'
import { Button } from "@/shared/components/common/Button/Button";
import { Input } from '@/shared/components/common/Input/Input';
import { Select } from '@/shared/components/common/Select/Select';
import { MONTH } from '@/shared/model/constants';
import useEditPlanPopup from './useEditPlanPopup';
import CreatePlanPopup from '../CreatePlanPopup/CreatePlanPopup';
import LoadingOverlay from "@/features/Sale/Dashboard/components/cards/_shared/LoadingOverlay/LoadingOverlay";
import Tooltip from "@/shared/components/organism/Tooltip/Tooltip";
function EditPlanPopup(props: EditPlanPopupProps) {
  const { open, onClose, id } = props;
  const {
    form,
    users,
    departments,
    planTypes,
    visibleMonth,
    loading,
    error,
    handleChange,
    handleSave,
    openCreatePopup,
    setOpenCreatePopup,
    handleDelete,
    description
  } = useEditPlanPopup(id, onClose);

  const isLoader = loading.departments || loading.planTypes || loading.users || loading.plans
  
  return (
    <>
      <Popup open={open} onClose={onClose} title='Редактирование плана' size='xl'>
        <form onSubmit={handleSave} className={css.actionPlanForm}>
          {isLoader && (
            <LoadingOverlay loading />
          )}
          <div className={newcss.actionPlanFormActions}>
            <Button type="button" onClick={() => setOpenCreatePopup(true)}>
              📋 Копировать
            </Button>
            <Button variant='danger' type="button" onClick={handleDelete}>
              🗑️ Удалить
            </Button>
          </div>
          <div className={css.actionPlanFormFields}>
            <div className={css.actionPlanFormFieldRow}>
              <label className={css.actionPlanFormLabel}>{
                `${planTypes.find(pt => pt.id === form.plan_type_id)?.plan_object ?? 'Целевое значение'} ${visibleMonth ? 'за месяц:' : 'за год:'}`
              }</label>
              <Input
                type="number"
                name="target_value"
                value={form.target_value}
                onChange={handleChange}
                required
              />
            </div>
            <div className={css.actionPlanFormFieldRow}>
              <label className={css.actionPlanFormLabel}>Год:</label>
              <Input
                type="number"
                name="year"
                value={form.year}
                onChange={handleChange}
                required
              />
            </div>
            {visibleMonth ? (
              <div className={css.actionPlanFormFieldRow}>
                <label className={css.actionPlanFormLabel}>Месяц:</label>
                <Select
                  name="month"
                  value={form.month ? String(form.month) : ''}
                  onChange={(value, name) => handleChange({ target: { name, value } } as any)}
                  required={visibleMonth}
                  options={[
                    { value: '', label: 'Выберите месяц' },
                    ...MONTH.map((m, idx) => ({ value: String(idx + 1), label: m }))
                  ]}
                />
              </div>
            ) : null}
            <div className={css.actionPlanFormFieldRow}>
              <label className={css.actionPlanFormLabel}>Подразделение:</label>
              <Select
                name="department_id"
                onChange={(value, name) => handleChange({ target: { name, value } } as any)}
                required
                options={[
                  { value: '', label: 'Выберите подразделение' },
                  ...(departments ? departments.map(d => ({ value: String(d.id), label: d.name })) : [])
                ]}
                value={form?.department_id ? String(form.department_id) : ''}
                loading={loading.departments}
                error={error.departments ? "Ошибка загрузки подразделений" : undefined}
                loadingText="Загрузка подразделений..."
                errorText={
                  error.departments
                    ? "Ошибка загрузки подразделений"
                    : (!loading.departments && departments.length === 0)
                      ? "Нет доступных подразделений"
                      : undefined
                }
              />
            </div>
            <div className={css.actionPlanFormFieldRow}>
              <label className={css.actionPlanFormLabel}>Исполнитель:</label>
              <Select
                name="user_id"
                value={form?.user_id ? String(form.user_id) : ''}
                onChange={(value, name) => handleChange({ target: { name, value } } as any)}
                required
                options={[
                  { value: '', label: 'Выберите исполнителя' },
                  ...(users ? users.map(u => ({ value: String(u.id), label: `${u.name} ${u.last_name}` })) : [])
                ]}
                loading={loading.users}
                error={error.users ? "Ошибка загрузки сотрудников" : undefined}
                loadingText="Загрузка сотрудников..."
                errorText={
                  error.users
                    ? "Ошибка загрузки сотрудников"
                    : (!loading.users && users.length === 0)
                      ? "Нет доступных сотрудников"
                      : undefined
                }
              />
            </div>
            <div className={css.actionPlanFormFieldRow}>
              <label className={css.actionPlanFormLabel}>Тип плана:</label>
              <Select
                name="plan_type_id"
                value={form?.plan_type_id ? String(form.plan_type_id) : ''}
                onChange={(value, name) => handleChange({ target: { name, value } } as any)}
                required
                options={[
                  { value: '', label: 'Выберите тип плана' },
                  ...(planTypes ? planTypes.map(pt => ({ value: String(pt.id), label: pt.name })) : [])
                ]}
                loading={loading.planTypes}
                error={error.planTypes ? "Ошибка загрузки типов планов" : undefined}
                loadingText="Загрузка типов планов..."
                errorText={
                  error.planTypes
                    ? "Ошибка загрузки типов планов"
                    : (!loading.planTypes && planTypes.length === 0)
                      ? "Нет доступных типов планов"
                      : undefined
                }
              />
            </div>
          </div>
          <div className={css.actionPlanFormSubmitWrapper}>
            <Tooltip
            text={description}
            >
              Подробнее о плане
            </Tooltip>

            <Button variant='success' type="submit" disabled={loading.planTypes || loading.users || loading.departments}>
              Сохранить
            </Button>
          </div>
        </form>
      </Popup>
      {Boolean(openCreatePopup) && (
        <CreatePlanPopup open={Boolean(openCreatePopup)} onClose={() => setOpenCreatePopup(false)} id={id ?? undefined} />
      )}
    </>
  )
}

export default EditPlanPopup